export default function prefixHttps(url: string) {
  url = url.trim();
  if (!url) return url;
  if (url.startsWith('https:')) return url;
  if (url.startsWith('http:')) return url.replace('http:', 'https:');
  if (url.startsWith('//')) return `https:${url}`;
  return `https://${url}`;
}
